if (typeof VideoCard !== 'function') {
  class VideoCard extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.playButton = this.querySelector('.video-slider__card-play');
      this.videoWrapper = this.querySelector('.video-slider__card-video');
      this.volumeButton = this.querySelector('.video-slider__card-volume');
      this.reviewTrigger = this.querySelector('.video-slider__card-review-trigger');
      this.videoSource = this.querySelector('.video-slider__card-video-video-source');

      this.init = this.init.bind(this);
      this.playHandle = this.playHandle.bind(this);
      this.videoPlayHandle = this.videoPlayHandle.bind(this);
      this.videoPauseHandle = this.videoPauseHandle.bind(this);
      this.videoEndedHandle = this.videoEndedHandle.bind(this);
      this.videoVolumeHandle = this.videoVolumeHandle.bind(this);
      this.reviewTriggerHandle = this.reviewTriggerHandle.bind(this);

      this.init();
      document.addEventListener('shopify:section:load', this.init);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:section:load', this.init);

      this.playButton.removeEventListener('click', this.playHandle);
      this.videoWrapper.removeEventListener('click', this.playHandle);
      this.videoSource.removeEventListener('play', this.videoPlayHandle);
      this.videoSource.removeEventListener('pause', this.videoPauseHandle);
      this.videoSource.removeEventListener('ended', this.videoEndedHandle);
      this.volumeButton.removeEventListener('click', this.videoVolumeHandle);
      this.reviewTrigger?.removeEventListener('click', this.reviewTriggerHandle);
    }

    init() {
      this.playButton.addEventListener('click', this.playHandle);
      this.videoWrapper.addEventListener('click', this.playHandle);
      this.videoSource.addEventListener('play', this.videoPlayHandle);
      this.videoSource.addEventListener('pause', this.videoPauseHandle);
      this.videoSource.addEventListener('ended', this.videoEndedHandle);
      this.volumeButton.addEventListener('click', this.videoVolumeHandle);
      this.reviewTrigger?.addEventListener('click', this.reviewTriggerHandle);
    }

    videoPlayHandle() {
      this.classList.add('video__playing');
    }

    videoPauseHandle() {
      this.classList.remove('video__playing');
    }

    videoEndedHandle() {
      this.videoSource.currentTime = 0;
    }

    videoVolumeHandle() {
      this.videoSource.muted = !this.videoSource.muted;
      this.classList.toggle('video__muted', this.videoSource.muted);
    }

    reviewTriggerHandle() {
      const isRevealed = this.classList.toggle('video__text-revealed');
      this.reviewTrigger.setAttribute('aria-pressed', String(isRevealed));
    }

    playHandle() {
      if (this.classList.contains('video__playing'))
        this.videoSource.pause();
      else
        this.videoSource.play();
    }
  }

  customElements.define('video-card', VideoCard);
}
